import React, { useEffect, useRef, useState } from 'react';
import '../../../assets/css/subscription.css';
import XCloseIcon from '../../../assets/img/x-circle.svg';
import { Link } from 'react-router-dom';
import Header from 'components/Header';
import { useAuth } from 'contexts/AuthContext';

const LeadSubCancel = () => {
  const { userCompany } = useAuth();
  return (
    <div className="wrapper">
      <div className="main-content">
        <section className="subscription-sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="blankList-box-cover">
                  <div className="blankList-box">
                    <img className="akarFile" src={XCloseIcon} />
                    <h2>Team Leader’s Subscription Expired 💔 </h2>
                    <p>
                      Your team leader’s subscription has expired. To continue using Happy Ending, please contact{' '}
                      <span className='text-capitalise'>{userCompany?.createdBy?.fullName}</span> to renew the plan.
                    </p>
                    {/* <Link to="/projects" className="btn-black">
                      Go to Dashboard
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LeadSubCancel;
